import { IResponse, PureRestRequest } from '@portals/fetch-api';
import { DowngradeCookieRequestType } from './types';
import { makeRequestConfig } from './make-request-config';

export const downgradeCookieRequest = (
  requestParams: DowngradeCookieRequestType,
): Promise<IResponse<{ success: string }>> =>
  new PureRestRequest().postRequest(makeRequestConfig(requestParams));
